import styled from 'styled-components'

interface IBudgetSubtotalListProps {}

export const BudgetSubtotalListStyled = styled.div<IBudgetSubtotalListProps>(
  (props) => {
    return `
      background: ${props.theme.colors.background};
      border-radius: ${props.theme.space.small};
      margin-left: -${props.theme.space.small};
      margin-right: -${props.theme.space.small};
      padding: ${props.theme.space.small};

      summary {
        list-style-type: none;
      }

      details {
        cursor: pointer;
      }
    `
  }
)
